module.exports = __webpack_public_path__ + "img/ring_a-2097.1e1ebef.webp";